"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
GroupService.$inject = ['api'];
function GroupService(api) {
}
exports.GroupService = GroupService;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/group/services/group.js
// module id = 482
// module chunks = 0